<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>语校体验</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="selClick"
      >
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="姓名/学校/内容关键词" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick">查询</el-button>
          <el-button type="success" :loading="exporting" @click="exportClick">导出Excel</el-button>
        </el-form-item>
      </el-form>

      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>语校体验列表</span>
        </div>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="userCode" label="用户编号" width="110"></el-table-column>
          <el-table-column prop="nickName" label="昵称" min-width="100"></el-table-column>
          <el-table-column prop="realName" label="姓名" width="100"></el-table-column>
          <el-table-column prop="mobile" label="手机" width="120"></el-table-column>
          <el-table-column prop="schoolName" label="语校" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column label="评分" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.score != null">{{ scope.row.score }} 星</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" width="160">
            <template slot-scope="scope">
              {{ scope.row.updateTime || scope.row.createTime || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="查看" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    plain
                    icon="el-icon-view"
                    @click="viewClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    plain
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog
      title="语校体验详情"
      :visible.sync="dialogVisible"
      width="760px"
      top="5vh"
      :close-on-click-modal="false"
    >
      <div class="detail-section">
        <div class="section-title">
          <i class="el-icon-user"></i>
          基本信息
        </div>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label">用户编号</div>
            <div class="detail-value">{{ form.userCode || "-" }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">昵称</div>
            <div class="detail-value">{{ form.nickName || "-" }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">姓名</div>
            <div class="detail-value">{{ form.realName || "-" }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">手机</div>
            <div class="detail-value">{{ form.mobile || "-" }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">语校</div>
            <div class="detail-value">{{ form.schoolName || "-" }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">评分</div>
            <div class="detail-value">
              <el-rate
                v-if="form.score != null"
                :value="Number(form.score) || 0"
                disabled
                :max="5"
                score-template="{value}"
              ></el-rate>
              <span v-else>-</span>
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">更新时间</div>
            <div class="detail-value">{{ form.updateTime || form.createTime || "-" }}</div>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <div class="section-title">
          <i class="el-icon-notebook-2"></i>
          体验内容
        </div>
        <div v-if="contentRows.length" class="qa-list">
          <div v-for="(item, idx) in contentRows" :key="idx" class="qa-item">
            <div class="qa-label">
              <span class="qa-index">{{ idx + 1 }}</span>
              {{ item.label }}
            </div>
            <div class="qa-value">
              <div class="qa-text">{{ item.value }}</div>
            </div>
          </div>
        </div>
        <div v-else class="empty-tip">暂无体验内容</div>
      </div>

      <span slot="footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";

var fieldOrder = [
  { key: "abroadDays", label: "赴日天数/时间" },
  { key: "schoolName", label: "语校名称" },
  { key: "environment", label: "校园环境" },
  { key: "teacher", label: "老师" },
  { key: "courses", label: "课程" },
  { key: "surrounding", label: "周边" },
  { key: "homework", label: "作业/学习" },
  { key: "advice", label: "建议/感想" }
];

export default {
  data() {
    return {
      key: "",
      loading: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      dialogVisible: false,
      form: {},
      contentRows: [],
      exporting: false
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    api(action) {
      return url.getMiniManage(action);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    selClick() {
      this.currentPage = 1;
      this.getList();
    },
    exportClick() {
      var _this = this;
      _this.exporting = true;
      var link = _this.api("Export_LangSchool") + "?key=" + encodeURIComponent(_this.key || "");
      var xhr = new XMLHttpRequest();
      xhr.open("GET", link, true);
      xhr.responseType = "blob";
      xhr.withCredentials = true;
      xhr.onload = function () {
        _this.exporting = false;
        if (xhr.status !== 200) {
          _this.$message.error("导出失败");
          return;
        }
        var blob = xhr.response;
        var a = document.createElement("a");
        var urlObj = window.URL.createObjectURL(blob);
        a.href = urlObj;
        a.download = "语校体验.xls";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(urlObj);
      };
      xhr.onerror = function () {
        _this.exporting = false;
        _this.$message.error("导出失败");
      };
      xhr.send();
    },
    getList() {
      var _this = this;
      _this.loading = true;
      $.get(
        _this.api("GetList_LangSchool"),
        {
          key: _this.key,
          pageindex: _this.currentPage,
          pagesize: _this.pageSize
        },
        function (data) {
          _this.loading = false;
          _this.tableData = data.list || [];
          _this.total = data.total || 0;
        }
      );
    },
    buildContentRows(contentJson) {
      var rows = [];
      if (!contentJson) return rows;
      var obj;
      try {
        obj = typeof contentJson === "string" ? JSON.parse(contentJson) : contentJson;
      } catch (e) {
        return [{ label: "原始内容", value: contentJson }];
      }
      if (!obj || typeof obj !== "object") return rows;

      var used = {};
      fieldOrder.forEach(function (f) {
        var v = obj[f.key];
        if (v == null || v === "") return;
        used[f.key] = 1;
        rows.push({ label: f.label, value: String(v) });
      });

      Object.keys(obj).forEach(function (k) {
        if (used[k]) return;
        if (k.indexOf("__") === 0) return;
        if (k === "stars" || k === "submitting" || k === "score" || k === "realName") return;
        var v = obj[k];
        if (v == null || v === "") return;
        rows.push({ label: k, value: String(v) });
      });
      return rows;
    },
    viewClick(row) {
      var _this = this;
      $.get(_this.api("GetModel_LangSchool"), { id: row.id }, function (data) {
        _this.form = data || {};
        _this.contentRows = _this.buildContentRows(data && data.contentJson);
        _this.dialogVisible = true;
      });
    },
    delClick(row) {
      var _this = this;
      this.$confirm("确定删除该条语校体验吗？", "提示", {
        type: "warning"
      })
        .then(function () {
          $.post(_this.api("Delete_LangSchool"), { id: row.id }, function (res) {
            if (res.status) {
              _this.$message.success(res.msg || "删除成功");
              _this.getList();
            } else {
              _this.$message.error(res.msg || "删除失败");
            }
          });
        })
        .catch(function () {});
    }
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding: 18px 16px 2px;
  background: #f2f2f2;
}
.detail-section {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 16px 18px 8px;
  margin-bottom: 14px;
}
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}
.section-title i {
  margin-right: 6px;
  color: #409eff;
}
.detail-grid {
  display: flex;
  flex-wrap: wrap;
}
.detail-item {
  width: 33.33%;
  box-sizing: border-box;
  padding: 0 12px 14px 0;
}
.detail-label {
  color: #909399;
  font-size: 12px;
  margin-bottom: 4px;
}
.detail-value {
  color: #303133;
  font-size: 14px;
  word-break: break-all;
}
.qa-list {
  padding-bottom: 6px;
}
.qa-item {
  padding: 12px 0;
  border-bottom: 1px dashed #ebeef5;
}
.qa-item:last-child {
  border-bottom: none;
}
.qa-label {
  color: #606266;
  font-size: 13px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  line-height: 1.5;
}
.qa-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-right: 8px;
  margin-top: 1px;
  border-radius: 50%;
  background: #ecf5ff;
  color: #409eff;
  font-size: 12px;
  flex-shrink: 0;
}
.qa-value {
  padding-left: 26px;
}
.qa-text {
  color: #303133;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  background: #f8f9fc;
  border-radius: 4px;
  padding: 10px 12px;
}
.empty-tip {
  color: #c0c4cc;
  padding: 12px 0 16px;
  text-align: center;
}
</style>
